import axios, { InternalAxiosRequestConfig } from "axios"
import { APP_CONFIG } from "../config/app.config"
import { tokenStorage } from "../../shared/lib/token"

export const http = axios.create({
  baseURL: APP_CONFIG.API_URL,
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // чистим токены
      localStorage.removeItem("access_token")
      localStorage.removeItem("refresh_token")

      // редирект
      window.location.href = "/login"
    }

    return Promise.reject(error)
  }
)

http.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = tokenStorage.get()

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  }
)
